import { request } from 'data/requests/request';

const authRequest = () => request({ type: 'quoteId', url: 'fast/token/index', notApi: true });

export default authRequest;
